import { AptCommodityType } from '../../../../common/enums/apttus/apt-commodity-typeof-sale';
import { AptProductFamily } from '../../../../common/enums/apttus/apt-product-family';
import { AptProductType } from '../../../../common/enums/apttus/apt-product-type';
import { D365CustomerSegment } from '../../../../common/enums/d365/d365-customer-segment';
import { SubProductType } from '../../../../common/enums/shared/sub-product-type';
import { ProductAddressType, ProductAddressTypesVisibilityCfg } from '../../models/product-address-visibility.types';

type ProductAddressesVisibility = {
    [key in ProductAddressType | 'DEFAULT']?: Partial<ProductAddressTypesVisibilityCfg>;
};

type SegmentProductAddressesVisibility = ProductAddressesVisibility & {
    [key in D365CustomerSegment]?: ProductAddressesVisibility;
};

export const PRODUCT_FAMILY_ADDRESS_MAP: SegmentProductAddressesVisibility = {
    // Configurazioni specifiche per Microbusiness
    [D365CustomerSegment.Microbusiness]: {
        DEFAULT: {
            SEDE_LEGALE: true,
            RESIDENZA: false
        }
    },
    // Configurazioni specifiche per Residenziale
    [D365CustomerSegment.Residential]: {
        [AptCommodityType.Power]: {
            RESIDENZA: true
        },
        [AptProductFamily.Assicurazione]: {
            RESIDENZA: true
        },
        INSURANCE_RC: {
            RESIDENZA: false
        },
        [SubProductType.RCDanni]: {
            RESIDENZA: false,
            DOMICILIO: true,
            ABITAZIONE_ABITUALE: true,
            ABITAZIONE_DI_PROPRIETA: true
        },
        [SubProductType.Implant]: {
            RESIDENZA: true,
            DOMICILIO: true,
            ABITAZIONE_ABITUALE: true,
            ABITAZIONE_DI_PROPRIETA: true
        },
        [SubProductType.Appliance]: {
            RESIDENZA: true,
            DOMICILIO: true,
            ABITAZIONE_ABITUALE: true,
            ABITAZIONE_DI_PROPRIETA: true
        },
        DEFAULT: {
            SEDE_LEGALE: false
        }
    },
    DEFAULT: {
        RESIDENZA: true,
        FATTURAZIONE: true
    },
    [AptCommodityType.Power]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        RESIDENZA: true
    },
    POWER_APPURTENANCES: {
        FORNITURA: true,
        SPEDIZIONE: false,
        RESIDENZA: true
    },
    [AptCommodityType.Gas]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        RESIDENZA: true
    },
    [AptProductFamily.BeniFisici]: {
        FORNITURA: false,
        SPEDIZIONE: true,
        RESIDENZA: true
    },
    [AptProductType.SmartHome]: {
        FORNITURA: false,
        SPEDIZIONE: true,
        RESIDENZA: true
    },
    // Manutenzione
    [AptProductType.Manutenzione]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        RESIDENZA: true
    },
    /* COMPLEX */
    [AptProductType.Complex_caldaia]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    },
    [AptProductType.Complex_comp_tecnica]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    },
    [AptProductType.Sopralluogo]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        RESIDENZA: true
    },
    [AptProductType.Complex_condizionatori]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    },
    [AptProductType.Complex_pompe_calore]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    },
    [AptProductType.Complex_scaldacqua]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    },
    [AptProductType.Complex_sist_ric_elettrica]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        CONSOCIATA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    },
    [AptProductFamily.VariazioneTecnica]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        RESIDENZA: true
    },
    [AptProductFamily.Assicurazione]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        FATTURAZIONE: false,
        RESIDENZA: true
    },
    INSURANCE_RC: {
        FORNITURA: true,
        SPEDIZIONE: false,
        FATTURAZIONE: false,
        RESIDENZA: true
    },
    [SubProductType.RCDanni]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        FATTURAZIONE: false,
        DOMICILIO: true,
        ABITAZIONE_ABITUALE: true,
        ABITAZIONE_DI_PROPRIETA: true,
        RESIDENZA: true
    },
    [SubProductType.Implant]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        FATTURAZIONE: false,
        DOMICILIO: true,
        ABITAZIONE_ABITUALE: true,
        ABITAZIONE_DI_PROPRIETA: true,
        RESIDENZA: true
    },
    [SubProductType.Appliance]: {
        FORNITURA: true,
        SPEDIZIONE: false,
        FATTURAZIONE: false,
        DOMICILIO: true,
        ABITAZIONE_ABITUALE: true,
        ABITAZIONE_DI_PROPRIETA: true,
        RESIDENZA: true
    },
    //BROADBAND
    [AptProductFamily.BroadBand]: {
        FORNITURA: true,
        FATTURAZIONE: true,
        RESIDENZA: true
    }
};
